const pasarela = {
  readPasarelas: 'pasarelas-pago',
  readPasarelasParametros: 'pasarela-pago/{{uuid_pasarela_pago}}/campos-parametros/{{uuid_academia}}'
}

export default pasarela
